import React from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Tabs, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import BlogForm from "./blogForm";
import SeoForm from "./seoMetaForm";
import axios from "axios";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const AddBlogs = () => {
  const [file, setFile] = useState([]);
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [placeholder, setPlaceholder] = useState(false);
  const navigate = useNavigate();

  const openNotification = (message, description) => {
    notification.open({
      message,
      description,
    });
  };
  const uploadProps = useMemo(
    () => ({
      beforeUpload: (file) => {
        const isImage = file?.type?.split("/")[0] === "image";
        if (!isImage) {
          openNotification("Error", "Please upload an image file.");
          return false;
        }
        const sanitizedFileName = file.name.replace(/\s+/g, "");
        const updatedFile = new File([file], sanitizedFileName, {
          type: file.type,
          uid: file.uid,
        });
        setFile([updatedFile]);
        return false;
      },
      onRemove: () => setFile([]),
    }),
    []
  );
  const uploadFiles = async (file) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_FRONTED_UPLOAD_IMAGE_URL}/getSignUrlForUpload`,
        {
          file: file[0],
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response?.data?.publicUrl || null;
    } catch (error) {
      openNotification("Error", "File upload failed.");
      return null;
    }
  };

  const onFinish = async (values) => {
    setLoader(true);
    const uploadedFilesUrl = placeholder
      ? "https://placehold.co/530x300?text=530x300&font=roboto"
      : await uploadFiles(file);
    console.log("uploadedFilesUrl", uploadedFilesUrl);
    if (uploadedFilesUrl !== false) {
      const payload = {
        title: [values.title, values.title2],
        domain: "Gng",
        SubTitleAndContent: values.SubTitleAndContent,
        image: uploadedFilesUrl,
        shortDescription: values.shortDescription,
        metaData: [
          {
            title: values.metaTitle,
            description: values.metaDescription,
            keywords: values.metaKeywords,
          },
        ],
      };
      axios
        .post(`${process.env.REACT_APP_FRONTED_URL}/blogs`, payload)
        .then(() => {
          form.resetFields();
          setLoader(false);
          navigate("/gng-blogs");
          openNotification("success", "Blog created successfully");
        })
        .catch((error) => {
          setLoader(false);
          console.error("Error creating blog:", error);
          openNotification("Error", error?.response?.data?.message);
        });
    }
  };

  const items = [
    {
      key: "1",
      label: "SEO Meta Tags",
      children: <SeoForm />,
    },
    {
      key: "2",
      label: "Blog Details",
      children: (
        <BlogForm
          imgRequired={placeholder ? false : true}
          uploadProps={uploadProps}
          setPlaceholder={setPlaceholder}
          file={file}
          showPlaceholder={true}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <Helmet>
        <title>Add Duomo Blogs</title>
        <meta name="description" content="Add and manage Duomo blogs" />
      </Helmet>
      <div className="header">
        <h3>Add Blogs</h3>
      </div>
      <div className="form_container">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Tabs defaultActiveKey="1" items={items} />
          <Form.Item>
            <div className="form_submit">
              <Button
                className="back_button"
                onClick={() => navigate("/gng-blogs")}
              >
                Back
              </Button>
              <Button htmlType="submit" type="primary">
                {loader ? "Please Wait..." : "Save"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default AddBlogs;
